import { bootstrapApplication } from '@angular/platform-browser';
import { Amplify } from 'aws-amplify';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { awsconfig } from './aws-amplify-config';

// Polyfill for $localize if not using i18n
if (typeof (globalThis as any).$localize === 'undefined') {
  (globalThis as any).$localize = (strings: TemplateStringsArray, ...values: any[]) => {
    return strings.reduce((result, str, i) => result + str + (values[i] || ''), '');
  };
}

Amplify.configure(awsconfig);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
